type EnumWithList<T> = {
  asList: () => T[];
};

/**
 * Calculates the index of a value in an enumeration list.
 * Should be used with the understanding that a higher index means a higher risk or value.
 * @param value Value to find the index of
 * @param enumObject Enumeration object that implements the asList() method
 * @returns Index of the value in the enumeration list, or -1 if not found
 * @throws Error if enumObject does not implement the asList() method or if asList()
 * does not return an array
 */
export const calculateOptionIndex = <T>(value: T, enumObject: EnumWithList<T>): number => {
  // Check if enumObject has the asList method
  if (!enumObject || typeof enumObject.asList !== 'function') {
    throw new Error('enumObject must have an asList() method');
  }

  const options = enumObject.asList();
  // Check if options is an array
  if (!Array.isArray(options)) {
    throw new Error('asList() method must return an array');
  }

  // Find the index of the value in the options array
  return options.findIndex((item) => item === value);
};
